import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { TextField, Typography } from "@material-ui/core";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import { UserContext } from "../../../contexts/UserContext";
import { PatronContext } from "../../../contexts/PatronContext";

const filter = createFilterOptions();

function SiteChooser() {
  const [allSites, setAllSites] = useState([]);
  const { Site, Sites, currentSite, userRole, changeSite, getMe, getAllSites } =
    useContext(UserContext);
  const { selectPatron } = useContext(PatronContext);

  const [selectedSite, setSelectedSite] = useState(null);
  const [inputValue, setInputValue] = React.useState("");

  const handleChange = async (event, site) => {
    if (site) {
      await changeSite(site.siteCode);
      setSelectedSite(site);
      if (typeof selectPatron === "function") {
        selectPatron();
      }
    }
  };

  useEffect(() => {
    if (userRole === "admin") {
      getAllSites().then((sites) => {
        const fetchedSites = Array.isArray(sites) ? sites : [];
        setAllSites(fetchedSites);

        const curSite = fetchedSites.find(
          (site) => site.siteCode === currentSite,
        );
        setSelectedSite(curSite || null);
      });
    } else {
      const standardSites = Array.isArray(Sites) ? Sites : [];
      const curSite = standardSites.find(
        (site) => site.siteCode === currentSite,
      );
      setSelectedSite(curSite || null);
    }
    // eslint-disable-next-line
  }, [userRole, currentSite, Sites]);

  // FIX: Pass the full array instead of just the first element `allSites[0]`
  const activeOptions = userRole === "admin" ? allSites : Sites || [];

  return (
    <Container>
      <SiteName>
        Current site: <Bold>{Site?.name || "None"}</Bold>
      </SiteName>
      {/* Defensive check: Ensure activeOptions is an array and has elements */}
      {Array.isArray(activeOptions) && activeOptions.length > 0 && (
        <Autocomplete
          id="site-chooser"
          options={activeOptions}
          getOptionLabel={(option) => option?.name || ""}
          getOptionSelected={(option, value) =>
            option?.siteCode === value?.siteCode
          }
          filterOptions={(options, params) => {
            return filter(options, params);
          }}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Select site" />
          )}
          value={selectedSite}
          onChange={handleChange}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue || "");
          }}
          autoSelect
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 5vw;
`;

const SiteName = styled(Typography)``;

const Bold = styled.span`
  font-weight: 700;
`;

export default SiteChooser;
